import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { AutoComplete } from 'primereact/autocomplete';
import { incomingStockService } from '../services/incomingStockService';
import './StockEntryRow.css';
import './ValidationErrors.css';
import { I18n } from 'react-redux-i18n';
import admin, { getMenuItem, getMenuItemAdmin } from '../../js/admin';
import auth, { featureEnabled } from '../../js/auth';
import { categorySelected } from '../../js/admin/incoming-stocks';
import { tmplparams } from '../../js/order-list-util';
import menuitemutil from '../../js/admin/menuitem';


// Recursively flatten activeMenuItems from activeMenuCategories
const flattenMenuItems = (menuCategories) => {
    if (!Array.isArray(menuCategories)) return [];
    let items = [];
    menuCategories.forEach(cat => {
        if (Array.isArray(cat.activeMenuItems)) {
            items = items.concat(cat.activeMenuItems);
        }
        if (Array.isArray(cat.activeMenuCategories)) {
            items = items.concat(flattenMenuItems(cat.activeMenuCategories));
        }
    });
    return items;
};

const mapStateToProps = (state) => ({
    products: state.rootReducer.menuCategories,
});

const productSearchCache = new WeakMap();

const normalizeSearchText = (value) => String(value || '').toLowerCase().trim();

const formatProductDisplayName = (product) => {
    if (!product) return '';

    const manufacturer = product.manufacturer || product.brand || product.supplier;
    const name = product.name || product.title || product.productName || product.itemName;

    if (name && name.trim() && name.trim() !== `Product ${product.id}`) {
        const productName = name.trim();
        return manufacturer && manufacturer.trim()
            ? `${manufacturer.trim()} - ${productName}`
            : productName;
    }

    if (product.label && product.label.trim()) {
        return product.label.trim();
    }
    if (product.displayName && product.displayName.trim()) {
        return product.displayName.trim();
    }
    if (product.text && product.text.trim()) {
        return product.text.trim();
    }

    return `Product ${product.id}`;
};

const formatProductCategoryPath = (product) => {
    if (!product) return '';

    if (product.categoryName) {
        return product.categoryName;
    }

    const category = product.category || product.categoryName || product.categoryPath;
    const subCategory = product.subCategory || product.subCategoryName;
    const parentCategory = product.parentCategory || product.parentCategoryName;

    const pathParts = [];

    if (parentCategory && parentCategory.trim()) {
        pathParts.push(parentCategory.trim());
    }

    if (category && category.trim() && category !== parentCategory) {
        pathParts.push(category.trim());
    }

    if (subCategory && subCategory.trim() && subCategory !== category) {
        pathParts.push(subCategory.trim());
    }

    return pathParts.length > 0 ? pathParts.join(' → ') : '';
};

const buildProductSearchIndex = (flatProducts = []) => {
    if (productSearchCache.has(flatProducts)) {
        return productSearchCache.get(flatProducts);
    }

    const index = flatProducts
        .filter(product => product && product.id && (product.defaultInventoryItem || product.isInventoryItem) &&
            (!product.entityType || !product.entityType.includes('Category')) &&
            product.name && product.name.trim() &&
            !product.name.toLowerCase().includes('category') &&
            product.name !== `Product ${product.id}`)
        .map(product => {
            const displayName = formatProductDisplayName(product);
            const categoryPath = formatProductCategoryPath(product);
            return {
                product,
                displayName,
                categoryPath,
                searchText: normalizeSearchText([
                    product.name,
                    product.manufacturer,
                    product.brand,
                    product.supplier,
                    product.label,
                    product.displayName,
                    product.text,
                    categoryPath,
                    displayName
                ].filter(Boolean).join(' '))
            };
        });

    productSearchCache.set(flatProducts, index);
    return index;
};

export const normalizeQuantityTypeUnit = (value) => {
    if (!value && value !== 0) return '';
    const rawValue = String(value).trim();
    const leftPart = rawValue.split(/[;,]/)[0]?.trim();
    const unitPart = rawValue.includes(';') || rawValue.includes(',')
        ? rawValue.split(/[;,]/).slice(1).join(';').trim()
        : rawValue;
    return (unitPart || leftPart || '').trim();
};

export const isPriceFieldEditable = (priceType, entry, currentInputPrice) => {
    const effectiveInputPrice = currentInputPrice || (typeof localStorage !== 'undefined' ? localStorage.input_price : 'net_unit_price') || 'net_unit_price';
    const hasSupplierCode = !!(entry && (entry.code || entry.supplier_code) && String(entry.code || entry.supplier_code).trim() !== '');

    if (hasSupplierCode) {
        return priceType === 'net_price';
    }

    return effectiveInputPrice === priceType;
};

export const findMatchingQuantityTypeSuggestion = (value, suggestions = []) => {
    if (!value && value !== 0) return null;

    const normalizedValue = String(value).trim();
    const rawUnit = normalizeQuantityTypeUnit(value);

    return suggestions.find(suggestion => {
        const suggestionValue = suggestion?.quantityType?.value || suggestion?.value || '';
        const suggestionLabel = suggestion?.label || '';
        const suggestionUnit = normalizeQuantityTypeUnit(suggestionValue);
        const labelUnit = normalizeQuantityTypeUnit(suggestionLabel);

        return suggestionValue === normalizedValue ||
            suggestionLabel === normalizedValue ||
            suggestionUnit === rawUnit ||
            labelUnit === rawUnit ||
            (rawUnit && suggestionValue?.includes(rawUnit)) ||
            (rawUnit && suggestionLabel?.includes(rawUnit));
    }) || null;
};

export const getQuantityTypeDisplayValue = (value, suggestions = []) => {
    if (!value && value !== 0) return '';

    const normalizedValue = String(value).trim();
    const suggestionMatch = findMatchingQuantityTypeSuggestion(value, suggestions);

    if (suggestionMatch) {
        return suggestionMatch.label || suggestionMatch.value || normalizedValue;
    }

    if (normalizedValue.includes(';') || normalizedValue.includes(',')) {
        const [quantity, unit] = normalizedValue.split(/[;,]/);
        if (unit) {
            return `${quantity.trim()} ${unit.trim()}`;
        }
    }

    return normalizedValue;
};

class StockEntryRow extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            supplierCodeSuggestions: [],
            productSuggestions: [],
            productInputValue: '',
            vatSuggestions: [],
            vatInputValue: '',
            storeSuggestions: [],
            storeInputValue: '',
            quantityTypeSuggestions: [],
            quantityTypeDisplaySuggestions: [], // For the dropdown display
            quantityTypeInputValue: '',
            showErrorTooltip: false,
            activeNumericField: null,
            numericInputDraft: ''
        };
    }

    componentDidMount() {
        // Don't calculate here - let the parent handle initial calculations
        // This prevents multiple rows from overwriting each other's updates

        const { entry, vatCategories = [], stores = [] } = this.props;
        if (entry && (entry.code || entry.supplier_code) && String(entry.code || entry.supplier_code).trim() !== '' && typeof localStorage !== 'undefined') {
            localStorage.input_price = 'net_price';
        }
        
        // Initialize input values if there are already selected items
        const updates = {};

        if (entry.menuItem) {
            const displayName = entry.menuItem.name && entry.menuItem.name !== `Product ${entry.menuItem.id}` ? 
                entry.menuItem.name : 
                this.formatProductName(entry.menuItem);
            updates.productInputValue = displayName;
            
            // Initialize quantity type options if product has availableQuantities
            if (entry.menuItem.availableQuantities) {
                this.updateQuantityTypeOptions(entry.menuItem);
            }
        }
        
        if (entry.vatCategory?.id && vatCategories && vatCategories.length > 0) {
            // Match by the full id first (format: "originalId;percent"), then by originalId
            const vatCategory = vatCategories.find(v => 
                v.id === entry.vatCategory.id || 
                v.originalId === entry.vatCategory.originalId ||
                v.originalId === entry.vatCategory.id
            );
            if (vatCategory) {
                updates.vatInputValue = vatCategory.name;
            }
        }
        
        if (entry.store?.id && stores && stores.length > 0) {
            const store = stores.find(s => s.id === entry.store.id);
            if (store) {
                updates.storeInputValue = store.name;
            }
        }
        
        // Initialize quantity type input value if there's existing data
        if (entry.quantityType && entry.menuItem) {
            updates.quantityTypeInputValue = getQuantityTypeDisplayValue(entry.quantityType, this.state.quantityTypeSuggestions || []);
        }
        
        if (Object.keys(updates).length > 0) {
            this.setState(updates);
        }
        
        // Call updateQuantityTypeOptions after state updates if we have a product
        if (entry.menuItem) {
            // Use setTimeout to ensure this runs after setState
            setTimeout(() => {
                this.updateQuantityTypeOptions(entry.menuItem);
            }, 0);
        }
    }

    showTooltip = (event, text) => {
        this.hideTooltip(); // Clear any existing tooltip
        
        const tooltip = document.createElement('div');
        tooltip.className = 'validation-error-tooltip';
        tooltip.innerHTML = text;
        tooltip.style.cssText = `
            position: fixed;
            background-color: #333;
            color: white;
            padding: 8px 12px;
            border-radius: 4px;
            font-size: 12px;
            z-index: 10000;
            max-width: 300px;
            white-space: pre-wrap;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
            line-height: 1.3;
            pointer-events: none;
        `;
        
        // Position tooltip relative to mouse cursor
        const rect = event.target.getBoundingClientRect();
        const tooltipX = rect.left + window.scrollX;
        const tooltipY = rect.bottom + window.scrollY + 5;
        
        tooltip.style.left = tooltipX + 'px';
        tooltip.style.top = tooltipY + 'px';
        
        // Adjust position if tooltip would be cut off by viewport
        document.body.appendChild(tooltip);
        const tooltipRect = tooltip.getBoundingClientRect();
        
        // Adjust horizontal position if cut off
        if (tooltipRect.right > window.innerWidth) {
            tooltip.style.left = (tooltipX - tooltipRect.width - 10) + 'px';
        }
        
        // Adjust vertical position if cut off
        if (tooltipRect.bottom > window.innerHeight) {
            tooltip.style.top = (rect.top + window.scrollY - tooltipRect.height - 5) + 'px';
        }
        
        this.currentTooltip = tooltip;
    }

    hideTooltip = () => {
        if (this.currentTooltip) {
            document.body.removeChild(this.currentTooltip);
            this.currentTooltip = null;
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // Only recalculate if count or multiplicator changed from external updates
        const { entry } = this.props;
        const prevEntry = prevProps.entry;
        
        if (entry.count !== prevEntry.count || entry.multiplicator !== prevEntry.multiplicator) {
            this.calculateOriginalQuantityIfNeeded();
        }
        
        // Update input values if items changed from external source OR if props changed
        const updates = {};

        this.getCostHostoryForEntry();

        const menuItem = prevState?.menuItem?.id === entry?.menuItem?.id ? prevState.menuItem : entry.menuItem;

        if (menuItem?.id !== prevEntry.menuItem?.id || this.props.products !== prevProps.products) {
            if (menuItem) {
                const displayName = menuItem.name && menuItem.name !== `Product ${menuItem.id}` ?
                    menuItem.name :
                    this.formatProductName(menuItem);
                updates.productInputValue = displayName;
                
                // Update quantity type options when menuItem changes
                if (menuItem.availableQuantities) {
                    this.updateQuantityTypeOptions(menuItem);
                }
            } else {
                updates.productInputValue = '';
                
                // Clear quantity type options when no product is selected
                this.setState({ 
                    quantityTypeSuggestions: [],
                    quantityTypeDisplaySuggestions: [],
                    quantityTypeInputValue: ''
                });
            }
        }
        
        if (entry.vatCategory !== prevEntry.vatCategory || this.props.vatCategories !== prevProps.vatCategories) {
            if (entry.vatCategory?.id && this.props.vatCategories && this.props.vatCategories.length > 0) {
                // Match by the full id first (format: "originalId;percent"), then by originalId
                const vatCategory = this.props.vatCategories.find(v => 
                    v.id === entry.vatCategory.id || 
                    v.originalId === entry.vatCategory.originalId ||
                    v.originalId === entry.vatCategory.id
                );
                updates.vatInputValue = vatCategory ? vatCategory.name : '';
            } else {
                updates.vatInputValue = '';
            }
        }
        
        if (entry.store !== prevEntry.store || this.props.stores !== prevProps.stores) {
            if (entry.store?.id && this.props.stores && this.props.stores.length > 0) {
                const store = this.props.stores.find(s => s.id === entry.store.id);
                updates.storeInputValue = store ? store.name : '';
            } else {
                updates.storeInputValue = '';
            }
        }
        
        // Update quantity type input value when quantityType changes
        if (entry.quantityType !== prevEntry.quantityType) {
            if (entry.quantityType) {
                updates.quantityTypeInputValue = getQuantityTypeDisplayValue(entry.quantityType, this.state.quantityTypeSuggestions || []);
            } else {
                updates.quantityTypeInputValue = '';
            }
        }
        
        if (Object.keys(updates).length > 0) {
            this.setState(updates);
        }
        
        // Ensure quantity type options are updated if product changed
        if ((entry.menuItem !== prevEntry.menuItem || this.props.products !== prevProps.products) && 
            entry.menuItem) {
            // Product data might have been enriched, update quantity types
            setTimeout(() => {
                this.updateQuantityTypeOptions(entry.menuItem);
            }, 0);
        }
    }

    getCostHostoryForEntry = () => {
        const { entry } = this.props;
        if (entry?.menuItem?.id && entry.quantity) {
            if (!(this.state.menuItem && this.state.menuItem.id === entry.menuItem.id)) {
                incomingStockService.getMenuItem(entry.menuItem.id).then(menuItem => {
                    if (menuItem) {
                        const displayName = this.formatProductName(menuItem);
                        this.setState({ menuItem: menuItem, productInputValue: displayName });
                    }
                });
            }
            if (entry?.menuItem?.id && entry.quantity && entry.store?.id && !(this.state.costHistory && this.state?.costHistory?.menuItem === entry?.menuItem?.id && this.state?.costHistory?.quantity === entry.quantity && this.state?.costHistory?.store?.id === entry?.store?.id && this.state.costHistory.expiry === entry.expiry && this.state.costHistory.date === entry.date)) {
                admin.getCostAndPriceHistoryAt(entry.menuItem.id, entry.quantity, entry.store.id, entry.expiry, entry.date, costHistory => {
                    if (costHistory) {
                        costHistory.date = entry.date;
                        costHistory.store = entry.store;
                        this.setState({ costHistory: costHistory })
                    }
                });
            }

        }
    }


    calculateOriginalQuantityIfNeeded = () => {
        const { entry, onChange, index } = this.props;
        
        // Auto-correct multiplicator if count and original_quantity exist but multiplicator is wrong
        if (entry.count && entry.original_quantity) {
            const count = parseFloat(entry.count);
            const originalQuantity = parseFloat(entry.original_quantity);
            if (!isNaN(count) && !isNaN(originalQuantity) && originalQuantity !== 0) {
                const expectedMultiplicator = Math.round((count / originalQuantity) * 1000) / 1000;
                
                // Only update if the calculated multiplicator is different from current multiplicator
                if (Math.abs((entry.multiplicator || 1) - expectedMultiplicator) > 0.001) {
                    const updatedEntry = { ...entry, multiplicator: expectedMultiplicator };
                    onChange(index, updatedEntry);
                }
            }
        }
    };

    handleFieldChange = (field, value) => {
        const { entry, onChange, index } = this.props;
        if (field === 'quantityType') {
            const oldvalue = entry.quantity + ";" + entry.quantityType;
            if (oldvalue === value) return; // No change
        }
        let updatedEntry = { ...entry, [field]: value };
        
        
        // Calculate multiplicator based on count and original_quantity (keep original_quantity unchanged)
        if (field === 'count' && value && updatedEntry.original_quantity) {
            const count = parseFloat(value);
            const originalQuantity = parseFloat(updatedEntry.original_quantity);
            if (!isNaN(count) && !isNaN(originalQuantity) && originalQuantity !== 0) {
                // Calculate multiplicator: count / original_quantity
                updatedEntry.multiplicator = Math.round((count / originalQuantity) * 1000) / 1000;
            }
        }
        
        // Set initial original_quantity only when count is set for the first time and no original_quantity exists
        if (field === 'count' && value && !updatedEntry.original_quantity) {
            const count = parseFloat(value);
            if (!isNaN(count)) {
                updatedEntry.original_quantity = Math.round(count * 1000) / 1000;
                updatedEntry.multiplicator = 1; // Initial multiplicator is 1
            }
        }
        
        // Clear multiplicator if count is cleared
        if (field === 'count' && !value) {
            updatedEntry.multiplicator = 1;
        }
        
        // Handle price calculations when relevant fields change
        if (['count', 'net_unit_price', 'brutto_unit_price', 'net_price', 'brutto_price', 'vatCategory'].includes(field)) {
            updatedEntry = incomingStockService.calculatePrices(updatedEntry, field);
        }
        
        onChange(index, updatedEntry);
    }

    handleProductChange = (value) => {
        const productIndex = this.getProductSearchIndex();
        const { productSuggestions } = this.state;
        let selectedProduct = null;
        let displayValue = '';
        
        // Handle clear action (when value is null, undefined, or empty string)
        if (!value || value === '') {
            this.setState({ productInputValue: '' });
            this.handleFieldChange('menuItem', null);
            return;
        }
        
        // Handle direct product object selection
        if (typeof value === 'object' && value !== null) {
            if (value.product) {
                // This is from our suggestions with embedded product
                selectedProduct = value.product;
                // Set input to the display name when product is selected
                displayValue = value.label || value.value;
            } else {
                selectedProduct = value;
                displayValue = formatProductDisplayName(selectedProduct);
            }
        } else if (typeof value === 'string') {
            // First try to find in current suggestions (most recent search results)
            const suggestionMatch = productSuggestions.find(s => 
                s.label === value || s.value === value
            );
            
            if (suggestionMatch) {
                selectedProduct = suggestionMatch.product;
                displayValue = suggestionMatch.label;
            } else {
                // Try to find product by various criteria
                selectedProduct = productIndex.map(item => item.product).find(p => {
                    const formattedName = formatProductDisplayName(p);
                    return p.name === value || 
                           formattedName === value ||
                           p.displayName === value ||
                           p.id === value;
                });
                
                displayValue = selectedProduct ? formatProductDisplayName(selectedProduct) : value;
            }
        }
        
        // Update the display value in state
        this.setState({ productInputValue: displayValue });
        
        // Save the complete product object as menuItem, but ensure it has an id
        const menuItemToSave = selectedProduct ? {
            id: selectedProduct?.product?.id || selectedProduct.id,
            type: (selectedProduct?.product?.entityType || selectedProduct.entityType).toLowerCase()
        } : null;
        
        // First save the menuItem
        this.handleFieldChange('menuItem', menuItemToSave);
        
        // Update quantity type options based on selected product
        if (selectedProduct && selectedProduct.availableQuantities) {
            // Use setTimeout to ensure menuItem update is processed before quantity type update
            setTimeout(() => {
                this.updateQuantityTypeOptions(selectedProduct);
            }, 0);
        } else if (!selectedProduct) {
            // Clear quantity type when no product is selected
            this.setState({ 
                quantityTypeSuggestions: [],
                quantityTypeDisplaySuggestions: [],
                quantityTypeInputValue: ''
            });
            this.handleFieldChange('quantityType', null);
        }
    }

    handleStoreChange = (value) => {
        const { stores } = this.props;
        const { storeSuggestions } = this.state;
        let selectedStore = null;
        
        // Handle clear action
        if (!value || value === '') {
            this.setState({ storeInputValue: '' });
            this.handleFieldChange('store', null);
            return;
        }
        
        // Update input value state
        this.setState({ storeInputValue: value || '' });
        
        // Handle direct store object selection
        if (typeof value === 'object' && value !== null) {
            if (value.store) {
                selectedStore = value.store;
                this.setState({ storeInputValue: value.label || value.value });
            } else {
                selectedStore = value;
            }
        } else if (typeof value === 'string') {
            // First try to find in current suggestions
            const suggestionMatch = storeSuggestions.find(s => 
                s.label === value || s.value === value
            );
            
            if (suggestionMatch) {
                selectedStore = suggestionMatch.store;
            } else {
                // Fallback: search in all stores
                selectedStore = stores.find(s => s.name === value);
            }
        }
        
        this.handleFieldChange('store', selectedStore ? { id: selectedStore.id } : null);
    }

    handleVATCategoryChange = (value) => {
        const { vatCategories } = this.props;
        const { vatSuggestions } = this.state;
        let selectedVAT = null;
        
        // Handle clear action
        if (!value || value === '') {
            this.setState({ vatInputValue: '' });
            this.handleFieldChange('vatCategory', null);
            return;
        }
        
        // Update input value state
        this.setState({ vatInputValue: value || '' });
        
        // Handle direct VAT object selection
        if (typeof value === 'object' && value !== null) {
            if (value.vat) {
                selectedVAT = value.vat;
                this.setState({ vatInputValue: value.label || value.value });
            } else {
                selectedVAT = value;
            }
        } else if (typeof value === 'string') {
            // First try to find in current suggestions
            const suggestionMatch = vatSuggestions.find(s => 
                s.label === value || s.value === value
            );
            
            if (suggestionMatch) {
                selectedVAT = suggestionMatch.vat;
            } else {
                // Fallback: search in all VAT categories
                selectedVAT = vatCategories.find(v => v.name === value);
            }
        }
        
        this.handleFieldChange('vatCategory', selectedVAT ? { id: selectedVAT.id, percent: selectedVAT.percent } : null);
    }

    handleQuantityTypeChange = (value) => {
        const { quantityTypeSuggestions } = this.state;
        let selectedQuantityType = null;
        
        // Handle clear action
        if (!value || value === '') {
            this.setState({ quantityTypeInputValue: '' });
            this.handleFieldChange('quantityType', null);
            return;
        }
        
        // Update input value state
        this.setState({ quantityTypeInputValue: value || '' });
        
        // Handle direct quantity type object selection
        if (typeof value === 'object' && value !== null) {
            if (value.quantityType) {
                selectedQuantityType = value.quantityType.value;
                this.setState({ quantityTypeInputValue: value.label || value.value });
            } else {
                selectedQuantityType = value;
            }
        } else if (typeof value === 'string') {
            const suggestionMatch = findMatchingQuantityTypeSuggestion(value, quantityTypeSuggestions);
            if (suggestionMatch) {
                selectedQuantityType = suggestionMatch.quantityType?.value || suggestionMatch.value;
            }
        }
        
        this.handleFieldChange('quantityType', selectedQuantityType); // Save only the unit part
    }

    handleSupplierCodeChange = (value) => {
        // Update supplier code
        this.handleFieldChange('code', value);
        
        // In the original implementation, when supplier code changes,
        // it fetches default product and multiplicator for that supplier
        // For now, we'll just trigger a recalculation of original_quantity
        const { entry } = this.props;
        if (entry.count) {
            const count = parseFloat(entry.count);
            if (!isNaN(count)) {
                const multiplicator = entry.multiplicator || 1;
                let originalQuantity;
                if (multiplicator !== 1) {
                    originalQuantity = Math.round(count / multiplicator * 1000) / 1000;
                } else {
                    originalQuantity = Math.round(count * 1000) / 1000;
                }
                this.handleFieldChange('original_quantity', originalQuantity);
            }
        }
    }

    handleSupplierCodeSearch = (event) => {
        // Use real suppliers from props instead of mock data
        const query = event.query.toLowerCase();
        const { suppliers } = this.props;
        
        if (!suppliers || suppliers.length === 0) {
            this.setState({ supplierCodeSuggestions: [] });
            return;
        }
        
        // Filter suppliers by name or any other supplier property
        const suggestions = suppliers
            .filter(supplier => {
                const supplierName = (supplier.name || '').toLowerCase();
                const supplierCode = (supplier.code || '').toLowerCase();
                return supplierName.includes(query) || supplierCode.includes(query);
            })
            .map(supplier => supplier.code || supplier.name || `Supplier ${supplier.id}`)
            .slice(0, 10); // Limit suggestions to prevent UI overflow
        
        this.setState({ supplierCodeSuggestions: suggestions });
    }

    handleVATSearch = (event) => {
        const query = event.query.toLowerCase().trim();
        const { vatCategories } = this.props;
        
        if (!vatCategories || vatCategories.length === 0) {
            this.setState({ vatSuggestions: [] });
            return;
        }
        
        let filteredVATs;
        if (!query || query.length === 0) {
            filteredVATs = vatCategories.slice(0, 10);
        } else {
            filteredVATs = vatCategories
                .filter(vat => {
                    const name = (vat.name || '').toLowerCase();
                    const percent = (vat.percent || '').toString().toLowerCase();
                    return name.includes(query) || percent.includes(query);
                })
                .slice(0, 10);
        }
        
        const suggestions = filteredVATs.map(vat => ({
            label: vat.name,
            value: vat.name,
            vat: vat
        }));
        
        this.setState({ vatSuggestions: suggestions });
    }

    handleStoreSearch = (event) => {
        const query = event.query.toLowerCase().trim();
        const { stores } = this.props;
        
        if (!stores || stores.length === 0) {
            this.setState({ storeSuggestions: [] });
            return;
        }
        
        let filteredStores;
        if (!query || query.length === 0) {
            filteredStores = stores.slice(0, 10);
        } else {
            filteredStores = stores
                .filter(store => {
                    const name = (store.name || '').toLowerCase();
                    return name.includes(query);
                })
                .slice(0, 10);
        }
        
        const suggestions = filteredStores.map(store => ({
            label: store.name,
            value: store.name,
            store: store
        }));
        
        this.setState({ storeSuggestions: suggestions });
    }

    handleQuantityTypeSearch = (event) => {
        const query = event.query.toLowerCase().trim();
        const { quantityTypeSuggestions } = this.state;
        
        // Use the suggestions that were already populated by product selection
        if (!quantityTypeSuggestions || quantityTypeSuggestions.length === 0) {
            this.setState({ quantityTypeDisplaySuggestions: [] });
            return;
        }
        
        let filteredQuantityTypes;
        if (!query || query.length === 0) {
            // Show all available quantity types for the selected product (for dropdown)
            filteredQuantityTypes = [...quantityTypeSuggestions];
        } else {
            // Filter by the query
            filteredQuantityTypes = quantityTypeSuggestions.filter(qt => {
                const label = (qt.label || '').toLowerCase();
                const value = (qt.value || '').toLowerCase();
                return label.includes(query) || value.includes(query);
            });
        }
        
        // Set the filtered suggestions for display
        this.setState({ quantityTypeDisplaySuggestions: filteredQuantityTypes });
    }

    isSelectableMenuItem = (item) => {
        if (!item || !item.id) return false;
        
        // Check if item has inventory properties (indicates it's a selectable menu item)
        const hasInventoryItem = item.defaultInventoryItem || item.isInventoryItem;
        
        // Check if it's not a category (categories usually have entityType containing "Category")
        const isNotCategory = !item.entityType || !item.entityType.includes('Category');
        
        // Check if it has a proper name (not just a category name)
        const hasValidName = item.name && item.name.trim() && 
                            !item.name.toLowerCase().includes('category') &&
                            item.name !== `Product ${item.id}`;
        
        
        return hasInventoryItem && isNotCategory && hasValidName;
    }

    getProductSearchIndex = () => buildProductSearchIndex(this.props.flatProducts || []);

    handleProductSearch = (event) => {
        const query = event.query.toLowerCase().trim();
        const productIndex = this.getProductSearchIndex();

        if (!productIndex || productIndex.length === 0) {
            this.setState({ productSuggestions: [] });
            return;
        }

        // For dropdown click (empty query), show first 15 products
        let filteredProducts;
        if (!query || query.length === 0) {
            filteredProducts = productIndex.slice(0, 15);
        } else {
            filteredProducts = productIndex.filter(product => product.searchText.includes(query)).slice(0, 15);
        }

        const suggestions = filteredProducts.map(product => {
            const displayName = product.displayName;
            const categoryPath = product.categoryPath;
            return {
                label: displayName,
                value: displayName,
                category: categoryPath,
                product: product
            };
        });

        this.setState({ productSuggestions: suggestions });
    }

    formatCategoryPath = (product) => {
        if (!product) return '';
        
        // First, try to build path from the hierarchical products structure
        const fullPath = product.categoryName;
        if (fullPath) {
            return fullPath;
        }
        
        // Fallback to product's direct category information
        const category = product.category || product.categoryName || product.categoryPath;
        const subCategory = product.subCategory || product.subCategoryName;
        const parentCategory = product.parentCategory || product.parentCategoryName;
        
        // Build category path
        const pathParts = [];
        
        if (parentCategory && parentCategory.trim()) {
            pathParts.push(parentCategory.trim());
        }
        
        if (category && category.trim() && category !== parentCategory) {
            pathParts.push(category.trim());
        }
        
        if (subCategory && subCategory.trim() && subCategory !== category) {
            pathParts.push(subCategory.trim());
        }
        
        const result = pathParts.length > 0 ? pathParts.join(' → ') : '';
        return result;
    }

    formatProductName = (product) => {
        const { flatProducts } = this.props;
        // Format similar to the service formatMenuItemName method
        if (!product);
        
        if (!flatProducts) return product.name || `Product ${product.id}`;
        
        // If product only has ID, find the full product from props
        if (product.id && product.name === undefined) {
            let fullProduct = null;
            
            // Flatten grouped flatProducts to find the complete product data
            flatProducts.forEach(item => {
                if (item.items && Array.isArray(item.items)) {
                    const found = item.items.find(p => p.id === product.id);
                    if (found) fullProduct = found;
                } else if (item.id === product.id) {
                    fullProduct = item;
                }
            });
            
            if (fullProduct) {
                product = fullProduct; // Use the complete product data
            }
        }
        
        // Handle different possible field names for manufacturer
        const manufacturer = product.manufacturer || product.brand || product.supplier;
        
        // Handle different possible field names for name
        const name = product.name || product.title || product.productName || product.itemName;
        
        // Build the formatted name with manufacturer prefix if available
        let formattedName = '';
        
        if (name && name.trim() && name.trim() !== `Product ${product.id}`) {
            const productName = name.trim();
            
            if (manufacturer && manufacturer.trim()) {
                formattedName = `${manufacturer.trim()} - ${productName}`;
            } else {
                formattedName = productName;
            }
            
            return formattedName;
        }
        
        // Fallback - check for other display fields, but avoid the Product ID fallback if possible
        if (product.label && product.label.trim()) {
            return product.label.trim();
        }
        if (product.displayName && product.displayName.trim()) {
            return product.displayName.trim();
        }
        if (product.text && product.text.trim()) {
            return product.text.trim();
        }
        
        // Last resort
        const fallback = `Product ${product.id}`;
        return fallback;
    }

    updateQuantityTypeOptions = (product) => {
        
        if (!product) {
            this.setState({ 
                quantityTypeSuggestions: [],
                quantityTypeDisplaySuggestions: []
            });
            return;
        }

        // Find the full product data from the cached search index
        const productIndex = this.getProductSearchIndex();

        if (productIndex && Array.isArray(productIndex) && product.id) {
            const fullProductEntry = productIndex.find(item => item.product.id === product.id);
            if (fullProductEntry) {
                product = fullProductEntry.product;
            }
        }
        
        if (!product.availableQuantities) {
            this.setState({ 
                quantityTypeSuggestions: [],
                quantityTypeDisplaySuggestions: []
            });
            return;
        }
        
        // Filter for inventory items only, like in original implementation
        const inventoryQuantities = product.availableQuantities.filter(q => q.inventoryItem === true);
        
        let quantityTypes = [];
        
        if (inventoryQuantities.length > 0) {
            // Use available quantities for inventory items
            quantityTypes = inventoryQuantities.map(quantity => {
                // Format: quantity + ";" + product.quantityType (like original implementation)
                const value = `${quantity.quantity};${product.quantityType}`;
                // For display, use quantity with unit (simplified version of getQuantityForCount)
                const displayText = `${quantity.quantity} ${I18n.t(`local.${product.quantityType}`) || ''}`;
                
                return {
                    label: displayText,
                    value: displayText,
                    quantityType: {
                        value: value,
                        name: displayText,
                        quantity: quantity.quantity,
                        baseQuantityType: product.quantityType
                    }
                };
            });
        } else {
            // Fallback to default quantity of 1 if no inventory quantities found
            const value = `1;${product.quantityType}`;
            const displayText = `1 ${I18n.t(`local.${product.quantityType}`) || ''}`;
            
            quantityTypes = [{
                label: displayText,
                value: displayText,
                quantityType: {
                    value: value,
                    name: displayText,
                    quantity: 1,
                    baseQuantityType: product.quantityType
                }
            }];
        }
        
        const stateUpdate = { 
            quantityTypeSuggestions: quantityTypes,
            quantityTypeDisplaySuggestions: quantityTypes
        };

        const existingQuantityType = this.props.entry?.quantityType;
        if (existingQuantityType) {
            stateUpdate.quantityTypeInputValue = getQuantityTypeDisplayValue(existingQuantityType, quantityTypes);
        } else if (quantityTypes.length === 1) {
            stateUpdate.quantityTypeInputValue = quantityTypes[0].label;

            // Use setTimeout to ensure this happens after the menuItem update is processed
            setTimeout(() => {
                this.handleFieldChange('quantityType', quantityTypes[0].quantityType.value)
            }, 10); // Small delay to ensure proper sequencing
        }
        
        this.setState(stateUpdate);
    }

    renderProductSuggestion = (item) => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', padding: '0.25rem 0' }}>
                <div style={{ fontWeight: 'normal', fontSize: '1rem' }}>
                    {item.label}
                </div>
                <div className="category-path" style={{ 
                    fontSize: '0.8rem', 
                    color: '#888', 
                    marginTop: '0.1rem',
                    fontStyle: 'italic',
                    opacity: item.category ? 1 : 0.5
                }}>
                    {item.category ? item.category : '(No category)'}
                </div>
            </div>
        );
    }

    handleDelete = () => {
        this.props.onDelete(this.props.index);
    };

    afternewitem = (newItem) => {
        if (!newItem || (Array.isArray(newItem) && newItem.length === 0)) {
            return;
        }

        const createdItem = Array.isArray(newItem) ? newItem[0] : newItem;
        const createdId = createdItem?.id;
        if (!createdId) {
            return;
        }

        incomingStockService.getMenuItems(true).then(data => {

            incomingStockService.getMenuItem(createdId).then(refreshedItem => {

                const selectedItem = refreshedItem && refreshedItem.id ? refreshedItem : createdItem;

                const menuItemToSave = {
                    id: selectedItem.id,
                    type: selectedItem.entityType ? selectedItem.entityType.toLowerCase() : (selectedItem.type || 'item')
                };

                /*
                this.setState({
                    menuItem: selectedItem,
                    productInputValue: formatProductDisplayName(selectedItem)
                });*/
                this.handleProductChange(formatProductDisplayName(refreshedItem));

                this.handleFieldChange('menuItem', menuItemToSave);
                this.updateQuantityTypeOptions(refreshedItem);
            });


            $('#editMenuItem').modal('hide');
            $('#newMenuItem').modal('hide');
        });
    };


    openAddMissingProductDialog = () => {
        const template = $('#newMenuItemTemplate');
        if (template.length === 0) {
            return;
        }

        if ($('#newMenuItem').length === 0) {
            admin.getMenuItems(data => { });
            template.tmpl({ ...tmplparams() }).appendTo('#IncomingStocksNew.p-dialog');
            admin.initializeSelect2($('#newMenuItem').find('select.select2'));
        }

        const newCategorySelected = () => categorySelected("#IncomingStocksNew.p-dialog", "afterNewItemExecuted");

        window.afterNewItemExecuted = this.afternewitem;

        // Template uses inline onclick="categorySelected()" so expose handler globally in this React context.
        window.categorySelected = newCategorySelected;
        window.featureEnabled = featureEnabled;
        window.menuitemutil = menuitemutil;
        $('#newMenuItem').find('select.select2').off('select2:select.stockEntryAdd').on('select2:select.stockEntryAdd', newCategorySelected);
        $('#newMenuItem .modal-footer .btn-primary').off('click.stockEntryAdd').on('click.stockEntryAdd', (e) => {
            e.preventDefault();
            newCategorySelected();
        });

        $('#newMenuItem').modal('show');
    };

    formatNumberInput = (value) => {
        return incomingStockService.formatNumber(value);
    };

    parseNumberInput = (value) => {
        return incomingStockService.parseNumber(value);
    };

    isInputPriceEnabled = (priceType) => {
        const { entry } = this.props;
        return isPriceFieldEditable(priceType, entry, localStorage.input_price);
    };

    handleNumericInputFocus = (field, value) => {
        this.setState({
            activeNumericField: field,
            numericInputDraft: value ?? ''
        });
    };

    handleNumericInputBlur = () => {
        this.setState({
            activeNumericField: null,
            numericInputDraft: ''
        });
    };

    handleNumericInputChange = (field, value) => {
        this.setState({ numericInputDraft: value });
        this.handleFieldChange(field, value);
    };

    getNumericInputValue = (field, value) => {
        const { activeNumericField, numericInputDraft } = this.state;
        if (activeNumericField === field) {
            return numericInputDraft;
        }
        return this.formatNumberInput(value);
    };

    render() {
        const { 
            entry, 
            index, 
            stores = [], 
            vatCategories = [], 
            products = [],
            suppliers = [],
            validationErrors = []
        } = this.props;
        
        const { 
            costHistory,
            menuItem,
            supplierCodeSuggestions, 
            productSuggestions, 
            productInputValue,
            vatSuggestions,
            vatInputValue,
            storeSuggestions,
            storeInputValue,
            quantityTypeSuggestions,
            quantityTypeDisplaySuggestions,
            quantityTypeInputValue,
            activeNumericField,
            numericInputDraft
        } = this.state;

        // Generate unique IDs for form elements
        const fieldId = (field) => `${field}${index}`;
        
        // Check if row has validation errors
        const hasErrors = validationErrors.length > 0;
        const errorTooltipText = validationErrors.join('; ');
        
        // Check if entry is complete and valid (has product and other required fields)
        const isCompleteAndValid = !hasErrors && 
            entry.menuItem && entry.menuItem.id && 
            entry.count && parseFloat(entry.count) > 0 && 
            entry.store && entry.store.id && 
            entry.vatCategory && entry.vatCategory.id && 
            entry.quantityType;
        
        // Check if entry has supplier code but no product (valid intermediate state)
        const isIntermediateState = entry.code && entry.code.trim() !== '' && 
            (!entry.menuItem || !entry.menuItem.id);

        var approvedCost = menuItem ? menuItem.availableQuantities.find(q => q.quantity === entry.quantity)?.approvedCost || "N/A" : "N/A";
        approvedCost = Math.round(approvedCost * (approvedCost < 10 ? 10 : 1)) / (approvedCost < 10 ? 10 : 1);
        const cost1 = costHistory && menuItem ? Math.round(((costHistory.cost * costHistory.count + entry.net_unit_price * parseFloat(entry.count)) / (costHistory.count + parseFloat(entry.count)))).toFixed(2) : "N/A";
        const cost = Math.round(cost1 * (cost1 < 10 ? 10 : 1)) / (cost1 < 10 ? 10 : 1);
        const costChange = Math.round(Math.abs(cost / approvedCost - 1) * 100);
        const costChangeThreshold = auth?.myStatus?.restaurant_settings["enabled-features"]?.inventory?.costChangeThreshold || 5;
        return (
            <tr 
                className={`selectable ${entry.ignored ? 'ignored' : ''} ${hasErrors ? 'validation-error' : ''} ${isCompleteAndValid ? 'validation-success' : ''}`} 
                level="2" 
                id={entry.id}
                style={hasErrors ? { backgroundColor: '#ffe6e6' } : isCompleteAndValid ? { backgroundColor: '#e6ffe6' } : {}}
            >
                {/* Warning/Success Icon Column */}
                <td className="status-icon" style={{ width: '30px', textAlign: 'center', padding: '5px', position: 'relative' }}>
                    {hasErrors && (
                        <i 
                            className="pi pi-exclamation-triangle" 
                            style={{ color: '#f56565', cursor: 'pointer' }}
                            title={errorTooltipText}
                            onMouseEnter={(e) => this.showTooltip(e, errorTooltipText)}
                            onMouseLeave={() => this.hideTooltip()}
                        />
                    )}
                    {!hasErrors && isCompleteAndValid && (
                        <i 
                            className="pi pi-check-circle" 
                            style={{ color: '#38a169', cursor: 'pointer' }}
                            title="All validation checks passed"
                            onMouseEnter={(e) => this.showTooltip(e, 'All validation checks passed')}
                            onMouseLeave={() => this.hideTooltip()}
                        />
                    )}
                    {!hasErrors && !isCompleteAndValid && !isIntermediateState && (
                        <i 
                            className="pi pi-minus-circle" 
                            style={{ color: '#a0aec0', cursor: 'default' }}
                            title="Incomplete entry"
                        />
                    )}
                </td>

                {/* Supplier Code */}
                {this.props.online_szamla !== false && (
                    <td tabIndex="1" className="selectable supplier-code" level="3" style={{ minWidth: '100%' }}>
                        <span className="mobile-only">Supplier Code</span>
                        <span className="supplier-text">{entry.code || ''}</span>
                    </td>
                )}

                {/* Original Quantity */}
                {this.props.online_szamla !== false && (
                    <td tabIndex="" className="browser-only original-quantity">
                        <InputText
                            value={entry.original_quantity ? this.formatNumberInput(entry.original_quantity) : ''}
                            onChange={(e) => this.handleFieldChange('original_quantity', e.target.value)}
                            id={fieldId('original_quantity')}
                            className="input input-numeral original_quantity"
                            readOnly
                        />
                    </td>
                )}

                {/* Product */}
                <td tabIndex="2" className="selectable product" level="3">
                    <span className="mobile-only">Product</span>
                    <div style={{ position: 'relative', width: '100%' }}>
                        <AutoComplete
                            value={productInputValue}
                            suggestions={productSuggestions}
                            completeMethod={this.handleProductSearch}
                            onChange={(e) => this.handleProductChange(e.value)}
                            onSelect={(e) => this.handleProductChange(e.value)}
                            onClear={() => {
                                this.handleProductChange('');
                            }}
                            field="label"
                            placeholder={I18n.t("admin_local.SEARCH_PRODUCTS")}
                            id={fieldId('product')}
                            className="product"
                            style={{ width: '100%' }}
                            minLength={0}
                            delay={300}
                            forceSelection={false}
                            itemTemplate={(item) => this.renderProductSuggestion(item)}
                        />
                        {productInputValue && (
                            <Button
                                icon="pi pi-times"
                                className="p-button-text p-button-sm"
                                onClick={() => {
                                    this.handleProductChange('');
                                }}
                                style={{
                                    position: 'absolute',
                                    right: '5px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    padding: '0.25rem',
                                    minWidth: 'auto',
                                    height: '1.2rem',
                                    width: '1.2rem',
                                    color: '#6c757d',
                                }}
                                tooltip="Clear product"
                                tooltipOptions={{ position: 'top' }}
                            />
                        )}
                        {!productInputValue && (
                            <Button
                                icon="pi pi-plus"
                                className="p-button-text p-button-sm"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.openAddMissingProductDialog();
                                }}
                                style={{
                                    position: 'absolute',
                                    right: '5px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    padding: '0.25rem',
                                    minWidth: 'auto',
                                    height: '1.2rem',
                                    width: '1.2rem',
                                    color: '#2b6cb0',
                                }}
                                tooltip={I18n.t("admin_local.ADD_MISSING_PRODUCT")}
                                tooltipOptions={{ position: 'top' }}
                            />
                        )}
                    </div>
                </td>

                {/* Quantity Type */}
                <td tabIndex="4" className="quantity-type" style={{ flexBasis: '150%' }}>
                    <span className="mobile-only">Quantity Type</span>
                    <div style={{ position: 'relative', width: '100%' }}>
                        <AutoComplete
                            value={quantityTypeInputValue}
                            suggestions={quantityTypeDisplaySuggestions}
                            completeMethod={this.handleQuantityTypeSearch}
                            onChange={(e) => this.handleQuantityTypeChange(e.value)}
                            onSelect={(e) => this.handleQuantityTypeChange(e.value)}
                            field="label"
                            placeholder={I18n.t("admin_local.SEARCH_QUANTITY_TYPES")}
                            id={fieldId('quantity_type')}
                            className="quantity_type"
                            style={{ width: '100%' }}
                            minLength={0}
                            delay={300}
                            forceSelection={false}
                            dropdown={true}
                        />
                        {quantityTypeInputValue && (
                            <Button
                                icon="pi pi-times"
                                className="p-button-text p-button-sm"
                                onClick={() => this.handleQuantityTypeChange('')}
                                style={{
                                    position: 'absolute',
                                    right: '5px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    padding: '0.25rem',
                                    minWidth: 'auto',
                                    height: '1.2rem',
                                    width: '1.2rem',
                                    color: '#6c757d',
                                }}
                                tooltip="Clear quantity type"
                                tooltipOptions={{ position: 'top' }}
                            />
                        )}
                    </div>
                </td>

                {/* VAT Category */}
                <td tabIndex="5" className="vat-category">
                    <span className="mobile-only">VAT Category</span>
                    <div style={{ position: 'relative', width: '100%' }}>
                        <AutoComplete
                            value={vatInputValue}
                            suggestions={vatSuggestions}
                            completeMethod={this.handleVATSearch}
                            onChange={(e) => this.handleVATCategoryChange(e.value)}
                            onSelect={(e) => this.handleVATCategoryChange(e.value)}
                            field="label"
                            placeholder={I18n.t("admin_local.SEARCH_VAT_CATEGORIES")}
                            id={fieldId('vat_category')}
                            className="vat_category"
                            style={{ width: '100%' }}
                            minLength={0}
                            delay={300}
                            forceSelection={false}
                            dropdown={true}
                        />
                        {vatInputValue && (
                            <Button
                                icon="pi pi-times"
                                className="p-button-text p-button-sm"
                                onClick={() => this.handleVATCategoryChange('')}
                                style={{
                                    position: 'absolute',
                                    right: '7px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    padding: '0.25rem',
                                    minWidth: 'auto',
                                    height: '1.2rem',
                                    width: '1.2rem',
                                    color: '#6c757d',
                                }}
                                tooltip="Clear VAT category"
                                tooltipOptions={{ position: 'top' }}
                            />
                        )}
                    </div>
                </td>

                {/* Quantity */}
                <td tabIndex="3" className="quantity">
                    <span className="mobile-only">Quantity</span>
                    <InputText
                        value={activeNumericField === 'count' ? numericInputDraft : (entry.count || '')}
                        onFocus={() => this.handleNumericInputFocus('count', entry.count || '')}
                        onBlur={this.handleNumericInputBlur}
                        onChange={(e) => this.handleNumericInputChange('count', e.target.value)}
                        id={fieldId('count')}
                        className="input input-numeral count"
                        placeholder=""
                        keyfilter="num"
                    />
                </td>

                {/* Net Unit Price */}
                <td tabIndex="6" className="net-unit-price">
                    <span className="mobile-only">Net Unit Price</span>
                    <InputText
                        value={this.getNumericInputValue('net_unit_price', entry.net_unit_price)}
                        onFocus={() => this.handleNumericInputFocus('net_unit_price', entry.net_unit_price || '')}
                        onBlur={this.handleNumericInputBlur}
                        onChange={(e) => this.handleNumericInputChange('net_unit_price', e.target.value)}
                        id={fieldId('net_unit_price')}
                        className="input input_price input-numeral net_unit_price"
                        placeholder=""
                        disabled={!this.isInputPriceEnabled('net_unit_price')}
                        keyfilter="num"
                    />
                </td>

                {/* Brutto Unit Price */}
                <td tabIndex="7" className="brutto-unit-price">
                    <span className="mobile-only">Brutto Unit Price</span>
                    <InputText
                        value={this.getNumericInputValue('brutto_unit_price', entry.brutto_unit_price)}
                        onFocus={() => this.handleNumericInputFocus('brutto_unit_price', entry.brutto_unit_price || '')}
                        onBlur={this.handleNumericInputBlur}
                        onChange={(e) => this.handleNumericInputChange('brutto_unit_price', e.target.value)}
                        id={fieldId('brutto_unit_price')}
                        className="input input_price input-numeral brutto_unit_price"
                        placeholder=""
                        disabled={!this.isInputPriceEnabled('brutto_unit_price')}
                        keyfilter="num"
                    />
                </td>

                {/* Net Price */}
                <td tabIndex="8" className="net-price">
                    <span className="mobile-only">Net Price</span>
                    <InputText
                        value={this.getNumericInputValue('net_price', entry.net_price)}
                        onFocus={() => this.handleNumericInputFocus('net_price', entry.net_price || '')}
                        onBlur={this.handleNumericInputBlur}
                        onChange={(e) => this.handleNumericInputChange('net_price', e.target.value)}
                        id={fieldId('net_price')}
                        className="input input_price input-numeral net_price"
                        placeholder=""
                        disabled={!this.isInputPriceEnabled('net_price')}
                        keyfilter="num"
                    />
                </td>

                {/* Brutto Price */}
                <td tabIndex="9" className="brutto-price">
                    <span className="mobile-only">Brutto Price</span>
                    <InputText
                        value={this.getNumericInputValue('brutto_price', entry.brutto_price)}
                        onFocus={() => this.handleNumericInputFocus('brutto_price', entry.brutto_price || '')}
                        onBlur={this.handleNumericInputBlur}
                        onChange={(e) => this.handleNumericInputChange('brutto_price', e.target.value)}
                        id={fieldId('brutto_price')}
                        className="input input_price input-numeral brutto_price"
                        placeholder=""
                        disabled={!this.isInputPriceEnabled('brutto_price')}
                        keyfilter="num"
                    />
                </td>

                {/* Expiry Date */}
                <td className="expiry-date" tabIndex="10">
                    <span className="mobile-only">Expiry Date</span>
                    <Calendar
                        value={entry.expiry_date ? new Date(entry.expiry_date) : null}
                        onChange={(e) => this.handleFieldChange('expiry_date', e.value ? e.value.getTime() : null)}
                        dateFormat="dd/mm/yy"
                        showIcon
                        id={fieldId('expiry')}
                        className="input expiry"
                        style={{ textAlign: 'center' }}
                    />
                </td>

                {/* Store */}
                <td className="last store" tabIndex="11" style={{ flexBasis: '150%' }}>
                    <span className="mobile-only">Store</span>
                    <div style={{ position: 'relative', width: '100%' }}>
                        <AutoComplete
                            value={storeInputValue}
                            suggestions={storeSuggestions}
                            completeMethod={this.handleStoreSearch}
                            onChange={(e) => this.handleStoreChange(e.value)}
                            onSelect={(e) => this.handleStoreChange(e.value)}
                            field="label"
                            placeholder={I18n.t("admin_local.SEARCH_STORES")}
                            id={fieldId('store')}
                            className="store"
                            style={{ width: '100%' }}
                            minLength={0}
                            delay={300}
                            forceSelection={false}
                            dropdown={true}
                        />
                        {storeInputValue && (
                            <Button
                                icon="pi pi-times"
                                className="p-button-text p-button-sm"
                                onClick={() => this.handleStoreChange('')}
                                style={{
                                    position: 'absolute',
                                    right: '5px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    padding: '0.25rem',
                                    minWidth: 'auto',
                                    height: '1.2rem',
                                    width: '1.2rem',
                                    color: '#6c757d',
                                }}
                                tooltip="Clear store"
                                tooltipOptions={{ position: 'top' }}
                            />
                        )}
                    </div>
                </td>

                <td className="approved_cost">
                    <div className={`a1 ${costChange > costChangeThreshold ? " warning" : ""}`} data-toggle='tooltip' title={`${I18n.t('admin_local.new_purchase_price') + " " + I18n.t('admin_local.approve_it_with_double_click')}`}>{approvedCost.toFixed(2)}</div>
                </td>
                <td className="cost_change">
                    {costChange > 0 ?
                        <div>
                            <div className="a2">
                                {cost > approvedCost ? "↗" : "↘"}
                            </div>
                            <div className={`a4 ${costChange > costChangeThreshold ? " warning" : ""}`}>{approvedCost > 0 ? (cost > approvedCost ? "+" + costChange : -(costChange)) + "%" : costChange}</div>
                        </div>
                        : null}
                </td>

                <td className="new_average_cost">
                    <div className={`a3 ${costChange > costChangeThreshold ? " warning" : ""}`} data-toggle='tooltip' title={`${I18n.t('admin_local.new_average_cost')}`}>{cost.toFixed(2)}</div>
                </td>

                {/* Delete Button */}
                <td className="deleteentry">
                    <Button
                        icon="pi pi-times"
                        className="p-button-danger p-button-rounded p-button-text"
                        onClick={this.handleDelete}
                        style={{ 
                            marginRight: '.5rem',
                            padding: '0px',
                            height: '1.7rem',
                            width: '2rem',
                            marginLeft: '.2rem'
                        }}
                    />
                </td>
            </tr>
        );
    }
}

export default connect(mapStateToProps)(StockEntryRow);